import { defineMessages } from 'react-intl';

export default defineMessages({
    locationHeading: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Heading",
        defaultMessage: "Location"
    },
    territoryCodeHeading: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Accordion.Territory Code",
        defaultMessage: "Territory Code"
    },
    countyHeading: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Accordion.County",
        defaultMessage: "County"
    },
    fullAddressHeading: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Accordion.Full Address",
        defaultMessage: "Full Address"
    },
    editLocation: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Edit Location",
        defaultMessage: "Edit Location"
    },
    premiumInfo: {
        id: "quoteandbind.wizard.commercial.TWIA.Location.Total Premium including Credits And Surcharges",
        defaultMessage: "Total Premium including Credits And Surcharges: {totalPremium}"
    },
    buildingAndLocation:{
        id: "quoteandbind.summary.commercial.Building and Location Details",
        defaultMessage: "Building and Location Details"
    },
    coverages:{
        id: "quoteandbind.summary.commercial.Location.Coverages",
        defaultMessage: "Coverages"
    }
})